module.exports = __webpack_public_path__ + "img/LHDN.9a2f17d9.png";